import React from "react";
import ErrorBoundary from "lib/ErrorBoundary";
import { NomuraLogo } from "app/header/Header";
import mountains from "app/header/images/mountains.png";
import { Navbar } from "react-bootstrap";
import { _t } from "app/i18n/i18n";
import { DataErrorMsg } from "pages/analystDirectory/AnalystDirectory";
import { BASENAME } from "lib/routing";
import { getCookie } from "lib/cookieUtils";

/* plays a vimeo video of a given vimeo video ID */
export const VideoPlayer = () => (
  <ErrorBoundary>
    <section className="d-flex">
      <section className="d-flex flex-column min-vh-100 w-100">
        <VideoHeader />
        <VideoContent />
        <VideoFooter />
      </section>
    </section>
  </ErrorBoundary>
);

const VideoHeader = () => (
  <Navbar bg="primary" variant="dark p-0">
    <Navbar.Brand href={BASENAME} title={_t("Home")} className="p-0 bg-white">
      <NomuraLogo />
      <img src={mountains} alt="mountains" />
    </Navbar.Brand>
  </Navbar>
);

const VideoContent = () => {
  const id = getCookie("grp-video-id");
  //useEffect(() => auditVimeoPlay(id), [id]); // contactless events unsupported
  if (!id || !sanitize(id)) return <DataErrorMsg />;

  return (
    <iframe
      src={"https://player.vimeo.com/video/" + id}
      width="100%"
      frameBorder="0"
      allow="autoplay; fullscreen; picture-in-picture"
      allowFullScreen
      className="flex-grow-1"
      title="video player"
    />
  );
};

const VideoFooter = () => <footer className="bg-dark text-white p-3">{enMsg}</footer>;

const enMsg = (
  <p className="text-break">
    Nomura podcasts and videos are presented for information only and are not Investment Research. The views or opinions
    expressed on the Nomura Connects site do not constitute investment advice and independent advice should be sought
    where appropriate. Full Disclosure information is available at&nbsp;
    <a href="https://www.nomuraholdings.com/policy/terms.html">https://www.nomuraholdings.com/policy/terms.html</a>.
  </p>
);

const sanitize = (str) => !isNaN(Number(str)); // allow only numbers
